



















import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'
import { Notify } from '@/helpers/Notify'
import { Helper } from '@/helpers/Helper'
import { Api } from '@/fetch/Api'

@Component
export default class NavBar extends Vue {
  callInProgress = false

  get Helper() {
    return Helper
  }

  public async logout() {
    this.callInProgress = true
    try {
      await Api.logout()
      store.commit('logout')
      this.$router.push({ path: '/login' })
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}

